module.exports = __webpack_public_path__ + "media/images/storeshelf-bc3761f16ab5c0cb14ecc4748319d414.jpg";